 <div class="row faketableheader col-12" *ngIf="cases && loaded">
    <div class="col-lg-1 col-2 click" (click)="sortResults($event, 'caseNumber');">{{ 'pages.support.dashboard.fieldTitles.reference' | translate }}<fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon></div>
    <div class="col">{{ 'pages.support.dashboard.fieldTitles.subject' | translate }}</div>
    <div class="col-lg-1 col-2 click" (click)="sortResults($event, 'priority');">{{ 'pages.support.dashboard.fieldTitles.priority' | translate }}<fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon></div>
    <div class="col-1 d-none d-lg-block">Owner</div>
    <div class="col-2 click" (click)="sortResults($event, 'type');">{{ 'pages.support.dashboard.fieldTitles.type' | translate }}<fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon></div>
    <div class="col-2 d-none d-lg-block click" (click)="sortResults($event, 'createdDate');">{{ 'pages.support.dashboard.fieldTitles.created' | translate }}<fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon></div>
    <div class="col-1" *ngIf="!main">{{ 'pages.generic.flag' | translate }}</div>
  </div>

  <div *ngIf="cases && loaded">
      <a *ngFor="let cc of cases" class="row faketablerow col-12" [routerLink]="['/xtended-soc/incident', cc.id]" style="text-decoration: none;">
          <div class="col-lg-1 col-2 faketablecell" ><span class="badge p-2 bg-light">{{cc.id}}</span></div>
          <div class="col faketablecell" style="text-align: left;">{{cc.subject | anonymise }}</div>
          <div class="col-lg-1 col-2 faketablecell px-1">
            <span class="badge p-2 w-100" style="color: initial;" [ngClass]="'P' + cc.severity | lowercase | removeWhiteSpace">{{cc.severity | severity | translate}}</span>
          </div>
          <div class="col-1 d-none d-lg-block faketablecell" *ngIf="cc.owner && cc.owner.length > 1">{{cc.owner | anonymise}}</div>
          <div class="col-1 d-none d-lg-block faketablecell" *ngIf="!cc.owner && cc.owner.length < 1"><span class="badge p-2 bg-light">N/A</span></div>


          <div class="col-2 faketablecell">{{cc.category}}</div>

          <div class="col-2 d-none d-lg-block faketablecell">{{cc.createdDate | date: 'dd/MM/yyyy HH:mm'}}</div>
          <div class="col-1 faketablecell" *ngIf="!main">
            <div class="spinner-grow spinner-grow-sm text-primary" *ngIf="flaggingRef && flaggingRef === cc.caseNumber">
              <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
            </div>

            <fa-icon [icon]="['far', 'flag']" class="click" (click)="flagCase($event, cc.id)" *ngIf="!flags.includes(cc.id) && !main"></fa-icon>
            <fa-icon [icon]="['fas', 'flag']" class="click" (click)="flagCase($event, cc.id)" *ngIf="flags.includes(cc.id) && !main"></fa-icon>
          </div>
      </a>
  </div>
 

  <div class="row justify-content-center p-5" *ngIf="!loaded || scrollLoading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
    </div>
  </div>

  <div class="row p-3 justify-content-center redborder-sides" *ngIf="loaded && cases && cases.length === 0">
    <div class="col-md-12 table-border justify-content-center">
      {{ 'pages.support.dashboard.noResults' | translate }}
    </div>
  </div>